import { auth } from "@/config/firebase";
import { isAdminToken, parseClaims } from "./claims";

/**
 * Bind a pending app-version-policy command to both the Firebase session and the backend
 * operator identity (`cardRefundMutationToken` pattern): a fresh token, and the same operator
 * before and after the refresh.
 */
export async function appVersionPolicyMutationToken(
  uid: string,
  backendId: string,
): Promise<string> {
  const user = auth.currentUser;
  if (!user || user.uid !== uid) throw new Error("Your sign-in changed. Reopen this policy.");
  const result = await user.getIdTokenResult(true);
  const claims = parseClaims(result);
  if (auth.currentUser?.uid !== uid || claims.backendId !== backendId || !isAdminToken(claims)) {
    throw new Error("Your operator access changed. Reopen this policy before continuing.");
  }
  return result.token;
}
